import { store } from '@betacrew/jars-flux'
export const componentKey = "RECONCILIATION_FORM_SUBMIT_POPUP";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setTempFormFieldsList: (state, action) => {
            state.tempFormFieldsList = [...action.payload];
        },
        setOnDependentFields: (state, action) => {
            state.onDependentFields = action.payload;
        },
        setToCreateFormData: (state, action) => {
            state.toCreateFormData = { ...state.toCreateFormData, ...action.payload };
        },
        setFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = action.payload;
        },
        updateFormsPreLoadedData: (state, action) => {
            state.formsPreLoadedData = {
                ...state.formsPreLoadedData,
                ...action.payload,
            }
        },
        updateUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {
                ...state.userInteractionPopupWResponseObj,
                ...action.payload,
            };
        },
        resetUserInteractionPopupWResponseObj: (state, action) => {
            state.userInteractionPopupWResponseObj = {};
        },
        setSuccessfullySubmittedReconciliation: (state, action) => {
            state.successfullySubmittedReconciliation = action.payload;
        },
        setFormDataFromRecordId: (state, action) => {
            state.formDataFromRecordId = action.payload;
        },
        setIsReconciliationEditModeOn: (state, action) => {
            state.isReconciliationEditModeOn = action.payload;
        },
    }, 
    initialReducerState: {
        loadingState: false,
        tempFormFieldsList: [],
        onDependentFields: {},
        formsPreLoadedData: {},
        toCreateFormData: {
            selectedYear: null,
            selectedForm: null,
            selectedState: null,
            selectedPayer: null,
        },
        userInteractionPopupWResponseObj: {},
        successfullySubmittedReconciliation: false,
        formDataFromRecordId: null,
        isReconciliationEditModeOn: false,
    }
});
export const {
    setLoadingState,
    setTempFormFieldsList,
    setFormsPreLoadedData,
    updateFormsPreLoadedData,
    setOnDependentFields,
    updateUserInteractionPopupWResponseObj,
    resetUserInteractionPopupWResponseObj,
    setToCreateFormData,
    setSuccessfullySubmittedReconciliation,
    setFormDataFromRecordId,
    setIsReconciliationEditModeOn,
} = actions;